var _path, _path2, _path3, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 724,
    height: 833,
    viewBox: "0 0 724 833",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M687.367 94.4521C687.367 92.798 688.696 91.457 690.334 91.457H694.945C696.584 91.457 697.912 92.798 697.912 94.4521V99.1063C697.912 100.76 696.584 102.101 694.945 102.101H690.334C688.696 102.101 687.367 100.76 687.367 99.1063V94.4521Z",
    fill: "#EBEDEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.335 81.2265C687.497 82.7274 688.767 83.8961 690.31 83.8961H695.973C697.526 83.8961 698.803 82.7116 698.951 81.196L717.389 56.6195C717.537 56.427 717.682 56.2326 717.826 56.0365L718.207 55.5287L718.192 55.5254C721.712 50.5072 723.777 44.3943 723.777 37.7988C723.777 20.733 709.948 6.89844 692.889 6.89844C675.829 6.89844 662 20.733 662 37.7988C662 43.7434 663.678 49.296 666.586 54.0083L666.557 54.009L666.716 54.217C667.721 55.8167 668.868 57.3177 670.14 58.7023L687.335 81.2265Z",
    fill: "url(#paint0_radial_2691_12953)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2691_12953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 662,
    y: 6,
    width: 62,
    height: 78
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.335 81.2265C687.497 82.7274 688.767 83.8961 690.31 83.8961H695.973C697.526 83.8961 698.803 82.7116 698.951 81.196L717.389 56.6196C717.537 56.427 717.682 56.2326 717.826 56.0365L718.207 55.5287L718.192 55.5254C721.712 50.5072 723.777 44.3943 723.777 37.7988C723.777 20.733 709.948 6.89844 692.889 6.89844C675.829 6.89844 662 20.733 662 37.7988C662 43.7434 663.678 49.296 666.586 54.0083L666.557 54.009L666.716 54.217C667.721 55.8167 668.868 57.3177 670.14 58.7023L687.335 81.2265Z",
    fill: "#333B47"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2691_12953)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.486 32.4369V45.651C683.486 46.4864 683.823 47.3219 684.454 47.851C684.832 48.1713 685.295 48.3801 685.87 48.3801H699.891C700.409 48.3801 700.872 48.1713 701.166 47.9485C701.966 47.3637 702.26 46.6118 702.274 45.6371C702.274 45.5674 702.288 45.5396 702.288 45.47V45.3586C702.274 42.8244 702.288 40.2623 702.288 37.7142C701.629 37.937 700.9 38.2154 700.493 38.4243C700.451 38.4382 700.409 38.4521 700.367 38.48V42.894C700.367 43.1446 700.353 43.3674 700.353 43.6041C700.353 44.0775 700.353 44.5649 700.353 45.0522C700.353 45.9852 700.423 46.4725 699.638 46.5143C699.512 46.5143 699.4 46.5004 699.288 46.5143C698.993 46.5561 688.436 46.5282 688.141 46.5282C687.847 46.5282 687.594 46.5143 687.314 46.5143C686.921 46.5143 686.038 46.5561 685.73 46.4168C685.533 46.3333 685.421 46.1383 685.421 45.8738C685.421 45.8042 685.407 45.7763 685.407 45.6928C685.407 45.6231 685.407 45.5535 685.407 45.4839C685.407 45.3307 685.393 45.2193 685.393 45.0801L685.379 40.8332C685.379 40.2345 685.393 39.6775 685.393 39.0927V36.4749C685.393 36.1686 685.407 35.9179 685.407 35.6116V32.9938C685.407 32.6736 685.379 32.0609 685.603 31.866C685.8 31.685 686.038 31.685 686.304 31.685C686.403 31.685 686.431 31.671 686.515 31.671C690.034 31.6293 693.651 31.671 697.157 31.671C697.591 31.671 699.498 31.6432 699.834 31.7128C700.101 31.7685 700.269 31.8938 700.325 32.1584C700.367 32.423 700.325 32.7432 700.353 33.0217C700.381 33.3002 700.367 33.6344 700.367 33.9268C700.367 34.247 700.381 34.5116 700.381 34.8179V35.5698C700.97 35.3331 701.587 35.1103 702.19 34.9432L702.288 34.9015V32.9521C702.288 32.2419 702.204 31.49 701.825 30.9191C701.783 30.8356 701.727 30.7799 701.671 30.6963C701.251 30.1672 700.409 29.7773 699.708 29.7773H686.094C685.744 29.7773 685.337 29.8887 685.015 30.0141C684.047 30.4179 683.486 31.3786 683.486 32.4369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.663 39.9991C693.565 39.9289 693.3 39.648 693.203 39.5356C692.966 39.3108 692.729 39.0861 692.464 38.9035L692.325 38.8051C692.283 38.7771 692.227 38.749 692.185 38.7209C692.144 38.6787 692.088 38.6506 692.046 38.6225C691.447 38.3276 690.861 38.1168 690.179 37.9342C689.579 37.7938 688.897 37.6252 688.256 37.6954C688.186 37.7095 688.116 37.7235 688.047 37.7376C688.047 37.9764 688.033 38.159 688.033 38.3978C688.033 38.6085 688.005 38.8473 688.005 39.058C688.005 39.5075 687.963 39.943 687.963 40.3925C688.019 40.3925 688.019 40.3784 688.088 40.3784C688.938 40.3784 689.301 40.3925 690.067 40.6874C690.541 40.856 690.973 41.1369 691.349 41.46C691.377 41.4881 691.391 41.5022 691.419 41.5303C691.558 41.6286 691.698 41.7831 691.809 41.9095L691.935 42.064C692.269 42.4714 692.52 42.8366 692.771 43.3002C693.022 43.7778 693.217 44.2694 693.384 44.7751C693.398 44.8453 693.426 44.9437 693.454 44.9999C693.537 44.9577 693.663 44.9296 693.76 44.9015L694.708 44.5925C694.819 44.5504 694.917 44.5223 695.014 44.4942L695.655 44.2835C695.753 44.2554 695.892 44.2273 695.976 44.1851C695.976 44.143 695.962 44.0868 695.962 44.0306C695.934 43.7918 695.892 43.5249 695.892 43.2721C695.892 43.2019 695.878 43.1878 695.878 43.1176C695.85 42.3309 695.92 41.6426 696.171 40.8981C696.324 40.4206 696.561 39.9991 696.84 39.5918L697.035 39.3249C697.202 39.1282 697.509 38.7771 697.704 38.6225C697.899 38.454 698.094 38.2854 698.303 38.1168L698.582 37.9202C698.777 37.7797 698.972 37.6533 699.181 37.5409C699.446 37.3724 699.85 37.1336 700.143 37.0212C700.198 36.9931 700.24 36.965 700.296 36.9369C700.352 36.9088 700.407 36.8948 700.463 36.8667C701.132 36.5295 702.637 35.9958 703.334 35.7991L704.086 35.5743C704.212 35.5322 704.337 35.4901 704.477 35.462C704.435 35.3917 704.17 34.268 704.142 34.1556L703.891 33.1864C703.863 33.088 703.849 32.9476 703.808 32.8633C703.64 32.8773 702.303 33.2987 702.149 33.3549C701.425 33.5656 700.672 33.8466 699.975 34.1416C699.906 34.1696 699.85 34.1977 699.78 34.2258L699.223 34.4646C699.167 34.5068 699.111 34.5349 699.042 34.563C698.916 34.6051 698.791 34.6753 698.679 34.7315C698.331 34.9282 697.983 35.1108 697.648 35.3355C697.216 35.6165 696.798 35.9115 696.394 36.2346C696.255 36.361 696.101 36.4734 695.962 36.6138C695.92 36.67 695.878 36.6981 695.823 36.7402C695.6 36.965 695.363 37.1897 695.168 37.4426L694.819 37.8921C694.415 38.4259 694.081 38.9878 693.816 39.5918C693.774 39.6761 693.663 39.9008 693.663 39.9991Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_2691_12953)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M668.064 37.7988C668.064 42.8724 669.286 47.6604 671.45 51.8842L666.05 53.1095C663.474 48.5961 662.001 43.3696 662.001 37.7988C662.001 20.733 675.821 6.89844 692.87 6.89844C693.892 6.89844 694.904 6.94824 695.901 7.04557C680.276 8.57025 668.064 21.757 668.064 37.7988ZM685.861 79.9286L692.861 70.7543V80.9028C692.861 82.4879 694.091 83.7852 695.648 83.8894C695.582 83.8938 695.514 83.8961 695.446 83.8961H689.788C688.235 83.8961 686.959 82.7116 686.811 81.196L685.861 79.9286ZM704.499 73.2565V68.198C706.168 67.8938 707.79 67.4553 709.354 66.8941L704.499 73.2565Z",
    fill: "white"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 471,
    r: 362,
    fill: "url(#paint1_linear_2691_12953)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.681,
    cy: 625.095,
    r: 106.962,
    fill: "#F7F9F8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.681,
    cy: 625.095,
    r: 106.962,
    fill: "black",
    fillOpacity: 0.05
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.49,
    cy: 465.984,
    r: 52.144,
    fill: "#F7F9F8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.49,
    cy: 465.984,
    r: 52.144,
    fill: "black",
    fillOpacity: 0.05
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.694,
    cy: 538.188,
    r: 20.0554,
    fill: "#F7F9F8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.694,
    cy: 538.188,
    r: 20.0554,
    fill: "black",
    fillOpacity: 0.05
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8292,
    cy: 58.8292,
    r: 58.8292,
    transform: "matrix(-1 0 0 1 647.789 280.672)",
    fill: "#F7F9F8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.8292,
    cy: 58.8292,
    r: 58.8292,
    transform: "matrix(-1 0 0 1 647.789 280.672)",
    fill: "black",
    fillOpacity: 0.05
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.6792,
    cy: 28.6792,
    r: 28.6792,
    transform: "matrix(-1 0 0 1 587.48 223.316)",
    fill: "#F7F9F8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.6792,
    cy: 28.6792,
    r: 28.6792,
    transform: "matrix(-1 0 0 1 587.48 223.316)",
    fill: "black",
    fillOpacity: 0.05
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0305,
    cy: 11.0305,
    r: 11.0305,
    transform: "matrix(-1 0 0 1 530.125 280.672)",
    fill: "#F7F9F8"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0305,
    cy: 11.0305,
    r: 11.0305,
    transform: "matrix(-1 0 0 1 530.125 280.672)",
    fill: "black",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2691_12953",
    x: 653.047,
    y: -2.05478,
    width: 65.26,
    height: 94.9025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.47661,
    result: "effect1_foregroundBlur_2691_12953"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2691_12953",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(670.903 25.0038) rotate(45.3073) scale(45.8995 36.8264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2691_12953",
    x1: 234.982,
    y1: 578.965,
    x2: 406.456,
    y2: 337.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F9F8",
    stopOpacity: 0.65
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.6db804f3080d695f84f4a343098079e9.svg";
export { ForwardRef as ReactComponent };